import request from '@/utils/request'
export const gettissuelist = (data: any) =>
  request({
    url: '/organization/getOrganList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getadminlist = (data: any) =>
  request({
    url: '/users/getUserInfo',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const gettpoiclist = (data: any) =>
  request({
    url: '/topic/getTopicInfo',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getExpertNum = (data: any) =>
  request({
    url: '/expert/getExpertInfo',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getRandomList = (data: any) =>
  request({
    url: '/expertlibrary/randomDram',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 绑定课题和指定评审专家
export const addExperts = (data: any) =>
  request({
    url: '/topicexpert/saveOrUpdate',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取绑定的线上专家的数组
export const getExpertsList = (data: any) =>
  request({
    url: '/expertlibrary/listByTopicId',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 查询专家汇总内容
export const getExpertReview = (data: any) =>
  request({
    url: '/topicexpert/getExpertReviewSummary',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 添加专家时候查询列表
export const getAddExList = (data: any) =>
  request({
    url: '/expertlibrary/list',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 专家针对课题上传的资源
export const uploadSource = (data: any) =>
  request({
    url: '/expertreviewresources/upload',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 根据课题id查询专家上传的资源
export const getFileList = (data: any) =>
  request({
    url: '/expertreviewresources/list',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const deleteUploadFile = (data: any) =>
  request({
    url: '/expertreviewresources/delete',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 综合评审的接口
export const updataStatus = (data: any) =>
  request({
    url: '/topic/updateStatus',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
